// constants/routes.ts

export const HOST = process.env.REACT_APP_API_HOST || 'http://localhost:8000';

// ─── Frontend page routes ─────────────────────────────────────────────────────
export const LOGIN                       = '/login';
export const SIGNUP                      = '/signup';
export const DASHBOARD                   = '/dashboard';
export const DASHBOARD_STATCREW          = `${DASHBOARD}/statcrew`;
export const DASHBOARD_STATCREW_ASSETS_XML = `${DASHBOARD}/statcrew/assets/xml`;
export const DASHBOARD_STATCREW_ASSETS_ROSTER = `${DASHBOARD}/statcrew/assets/roster`;
export const DASHBOARD_STATCREW_ASSETS_SCHEDULE = `${DASHBOARD}/statcrew/assets/schedule`;
export const DASHBOARD_STATCREW_UPLOAD = `${DASHBOARD}/statcrew/upload`;
export const DASHBOARD_STATCREW_REVIEW = `${DASHBOARD}/statcrew/review`;
/** Alias for in-app upload navigation (includes ``/dashboard`` prefix). */
export const STATCREW_UPLOAD_PAGE        = DASHBOARD_STATCREW_UPLOAD;
export const DASHBOARD_CONFERENCE_HISTORY = `${DASHBOARD}/conference-history`;
export const DASHBOARD_POST_GAME_SEASON  = `${DASHBOARD}/post-game-season`;
export const DASHBOARD_ADMIN               = `${DASHBOARD}/admin`;
export const DASHBOARD_ADMIN_CONFERENCE_CONFLICTS = `${DASHBOARD_ADMIN}/conference-conflicts`;
export const ADMIN                         = `${DASHBOARD}/admin`;

// ─── API endpoints ────────────────────────────────────────────────────────────
export const USER_LOGIN                  = `${HOST}/auth/login`;
export const AUTH_REFRESH                = `${HOST}/auth/refresh`;
export const DASHBOARD_DATA              = `${HOST}/dashboard/data`;
export const DASHBOARD_CONFERENCE_HISTORY_API = `${HOST}/dashboard/conference-history`;
export const DASHBOARD_CONFERENCE_LOOKUP_API = `${HOST}/dashboard/conference-lookup`;
export const DASHBOARD_POST_GAME_SEASON_API = `${HOST}/dashboard/post-game-season`;
export const STATCREW_DATA               = `${HOST}/statcrew/data`;
export const STATCREW_UPLOAD_CONFIRM     = `${HOST}/upload/confirm`; // ← API POST
export const STATCREW_UPLOAD_MAP_TEAM_IDENTITY = `${HOST}/upload`;
export const STATCREW_VALIDATE_ZIP       = `${HOST}/upload/init`;
export const STATCREW_VALIDATE_SCHEDULE  = `${HOST}/upload/validate/schedule`;
export const STATCREW_VALIDATE_ROSTER    = `${HOST}/upload/validate/roster`;
export const STATCREW_UPLOAD_GAME_XML    = `${HOST}/upload/xml`;
export const TEAM_ENTITLEMENTS          = `${HOST}/entitlements`;
export const SUPPORT_CONTACT_URL         = `${HOST}/support/contact`;

// Admin API endpoints
export const ADMIN_JOBS_URL               = `${HOST}/admin/jobs`;
export const ADMIN_CONFERENCE_CONFLICTS_URL = `${HOST}/admin/conference-conflicts`;
export const getAdminRetryJobUrl = (jobId: string): string => `${HOST}/admin/jobs/${jobId}/retry`;
export const getAdminDeleteJobUrl = (jobId: string): string => `${HOST}/admin/jobs/${jobId}`;
export const getAdminResolveConflictUrl = (conflictId: string): string => `${HOST}/admin/conference-conflicts/${conflictId}/resolve`;

// ─── Dynamic Upload Routes ────────────────────────────────────────────────────
export const getUploadScheduleUrl = (jobId: string): string => `${HOST}/upload/${jobId}/schedule.generated.json`;
export const getUploadRosterUrl = (jobId: string): string => `${HOST}/upload/${jobId}/roster.generated.json`;
export const getJobLifecycleUrl = (jobId: string): string => `${HOST}/jobs/${jobId}/lifecycle`;
export const getJobReviewUrl = (jobId: string): string => `${HOST}/jobs/${jobId}/review`;
export const getJobReviewPgsUrl = (jobId: string): string => `${HOST}/jobs/${jobId}/review/pgs`;
export const getJobReviewTgsUrl = (jobId: string): string => `${HOST}/jobs/${jobId}/review/tgs`;
export const getJobReviewRosterMapUrl = (jobId: string): string => `${HOST}/jobs/${jobId}/review/roster/map`;
export const getJobReviewRosterMapBatchUrl = (jobId: string): string => `${HOST}/jobs/${jobId}/review/roster/map/batch`;
export const getJobApproveUrl = (jobId: string): string => `${HOST}/jobs/${jobId}/approve`;